module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/continue_primary.dc680623c05dccd97e9437eed37fa0f6.svg";